import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { ProgressBarMode, MatProgressBarModule } from '@angular/material/progress-bar';
import { AlertaService } from '../alerta/alerta.service';
import { LoadingService } from '../loading/loading.service';
import { UsuarioService } from '../usuario/usuario.service';
import { TableroService } from './tablero.service';
import { selectUsuario } from '../states/usuario/selector';
import { Store, select } from '@ngrx/store';
import { AppState } from '../app.state';
import { iUsuario } from '../usuario/usuario.interface';
import { MatListModule } from '@angular/material/list';
import { CommonModule } from '@angular/common';
import moment from 'moment';
import { ThemePalette } from '@angular/material/core';

@Component({
  selector: 'app-tablero',
  standalone: true,
  imports: [MatCardModule, MatButtonModule, MatTabsModule, MatIconModule, MatListModule, MatProgressBarModule, CommonModule],
  templateUrl: './tablero.component.html',
  styleUrl: './tablero.component.css'
})
export class TableroComponent {
  private loadingService = inject(LoadingService);
  private tableroService = inject(TableroService);
  private usuarioService = inject(UsuarioService);
  private alertaService = inject(AlertaService);

  public readonly store: Store<AppState> = inject(Store);
  public readonly stateUsuario: any = this.store.pipe(select(selectUsuario));
  public oUsuario: iUsuario;
  public isloadingUsuario = false;
  public progress_mode: ProgressBarMode = 'indeterminate';
  public progress_color: ThemePalette = 'primary';

  public moment: any = moment;
  public temas: any[] = [];
  public showReport: boolean = false;
  public rows: any = {};
  public rol: number = 0;

  private nombresTemas: any = {
    '-KcOsYIkmr2FHgi4ubym': 'Corporativo',
    '-KcOsYIoTX3wdcK4DMjF': 'Corporativo Confidencial',
    '-KcOsYIprL1TVCF2uyaO': 'Personal',
    '-KdfegAIz9pHjb6ak32K': 'Personal Confidencial'
  };

  constructor() {
    this.oUsuario = structuredClone(this.stateUsuario.state().usuario);

    let temas = Object.keys(this.oUsuario.temas);

    if(temas.length > 0) {
      for(const i in temas) {
        let tema = temas[i];
        this.temas.push({id: tema, nombre: this.nombresTemas[tema], vencidas: [], vigentes: [], xvencer: []});
      }
    } else {
      this.temas = [
        {id: '-KcOsYIkmr2FHgi4ubym', nombre: 'Corporativo',              vencidas: [], vigentes: [], xvencer: []},
        {id: '-KcOsYIoTX3wdcK4DMjF', nombre: 'Corporativo Confidencial', vencidas: [], vigentes: [], xvencer: []},
        {id: '-KcOsYIprL1TVCF2uyaO', nombre: 'Personal',                 vencidas: [], vigentes: [], xvencer: []},
        {id: '-KdfegAIz9pHjb6ak32K', nombre: 'Personal Confidencial',    vencidas: [], vigentes: [], xvencer: []}
      ];
    }
  }

  async ngOnInit() {
    this.store.select(selectUsuario).subscribe((oUsuario) => {
      this.oUsuario = structuredClone(oUsuario);
      if(this.isloadingUsuario == false && oUsuario.activo) {
        this.isloadingUsuario = true;
        this.inicializa();
      }
    });
  }

  inicializa () {
    this.tableroService.obtenerTablero(this.oUsuario).subscribe({
      next: (data: any) => {
        for(const i in data) {
          let tema = data[i];
          if(tema.vigentes.length > 0 || tema.xvencer.length > 0 || tema.vencidas.length > 0) {
            tema.descargaReporte = true;
          }
        }

        this.temas = data;
        this.progress_color = 'primary';
        this.progress_mode = 'determinate';
      },
      error: (error) => {
        console.log(error);
        this.alertaService.open('Error', 'Ups tenemos problemas al obtener los datos');
      },
      complete: () => {
        console.log('complete');
      },
    });
  }

  descargaReporte (tema: any) {
    this.loadingService.show();

    this.tableroService.obtenerDescarga({
      temaId : tema.id,
      uid: this.oUsuario.uid, 
      rol: this.oUsuario.rol
    }).subscribe({
      next: (dataFile: any) => {
        if (!dataFile.error) {
          this.download(dataFile);
        } else {
          this.alertaService.open("Error 040", dataFile.message);
        }
      },
      error: (error) => {
        console.log(error);
        this.alertaService.open('Error', 'Ups tenemos problemas al obtener los datos');
      },
      complete: () => {
        console.log('complete');
        this.loadingService.hide();
      },
    });
  }

  download(data: BlobPart) {
    var blob = new Blob([data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    let fileName = `Reporte de Seguimiento - ${moment().format('YYYY/MM/DD HH:mm:ss')}.xlsx`;
    var link = document.createElement("a");

    link.id = 'Reporte_de_Seguimiento';
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    link.click();

    this.loadingService.hide();
    // Revocar el objeto URL y eliminar el elemento por clase
    setTimeout(() => {
      window.URL.revokeObjectURL(link.href);
      const elements = document.getElementById('Reporte_de_Seguimiento');
      elements?.remove();
    }, 2000);
  }

  verEntrada (item: any) {
    window.open(`/entrada/${item.tema}/${item.id}`, '_blank');
  }
}